import React, { ReactElement, useState } from 'react'
import classes from './ConfirmTooltip.module.scss'
import { Tooltip } from 'react-tooltip'
import Button from '@/components/ui/Buttons/Button'
import Typography from '@/components/ui/Typography'
import { generateId } from '@/utils/string'

export type ConfirmTooltipProps = {
  content?: string
  children: ReactElement<{ onClick: (event: React.MouseEvent<HTMLButtonElement>) => void; 'data-tooltip-id'?: string }>
}

/**
 * Component for wrapping the button with onClick event for confirmation
 */
const ConfirmTooltip = ({ content = "This action can't be undone", children }: ConfirmTooltipProps) => {
  const [id] = useState(generateId('delete_route_'))
  const [isOpen, setIsOpen] = useState(false)

  const handleConfirm = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation()
    children.props.onClick?.(event)
    setIsOpen(false)
  }
  const showTooltip = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation()
    setIsOpen(true)
  }

  const hideTooltip = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation()
    setIsOpen(false)
  }

  return (
    <div onClick={(event) => event.stopPropagation()} role={'presentation'}>
      {React.cloneElement(children, {
        'data-tooltip-id': id,
        onClick: isOpen ? hideTooltip : showTooltip,
      })}

      {isOpen && (
        <Tooltip
          id={id}
          className={classes.root}
          isOpen={isOpen}
          openOnClick
          closeEvents={{ click: true }}
          clickable
          render={() => (
            <div>
              <Typography>{content}</Typography>
              <div className={classes.row}>
                <Button onClick={handleConfirm}>Confirm</Button>
                <Button variant={'soft'} onClick={hideTooltip}>
                  Cancel
                </Button>
              </div>
            </div>
          )}
        />
      )}
    </div>
  )
}

export default ConfirmTooltip
